import { useRouter } from 'next/router';

export default function Banner({ banner }) {
  const router = useRouter();

  const { locale } = router;

  return (
    <div
      className="lg:block bg-gold text-grey text-11 px-1 lg:text-14 font-semibold text-center top-0 fixed z-50 w-full"
      role="banner"
    >
      <div className="mx-auto banner lg:w-7/12 flex items-center justify-between lg:justify-center">
        <img
          src="/img/crowdfunding/banner/coin.png"
          width="50"
          height="50"
          alt="Finary plus icon"
          className="mr-1"
        />
        <p className="w-7/12 lg:w-9/12 text-left lg:text-center">{banner.text[locale]}</p>
        <a
          target="_blank"
          rel="nofollow noopener"
          href={banner.link[locale]}
          className="ml-2 bg-grey-800 text-white cursor-pointer px-1 uppercase text-10 lg:text-12"
          style={{ padding: '5px 20px' }}
        >
          {banner.cta[locale]} →
        </a>
      </div>
      <style jsx>{`
        .banner {
          background-image: url(/img/components/banner/bg-left.png),
            url(/img/components/banner/bg-right.png);
          background-position: left 5% bottom, right -20px bottom;
          background-size: 170px, 170px;
          background-repeat: no-repeat;
        }

        @media screen and (max-width: 992px) {
          .banner {
            background-image: none;
          }
        }
      `}</style>
    </div>
  );
}
